/**
 *
 * Asynchronously loads the component for AppWrapper
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const AppWrapper = lazyLoad(
  () => import('./index'),
  module => module.AppWrapper,
);
